import { PerformanceDatapoint } from 'owa-analytics';
import type { TableView } from 'owa-mail-list-store';
import type { ActionSource } from 'owa-mail-store';
import { setMailListLoadDatapoint } from './mailListLoadDatapointGetterAndSetter';
import endMailListLoadDatapoint from './endMailListLoadDatapoint';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';

let eventTimestamp: number | undefined = undefined;

export function setInteractionTimestamp(timeStamp?: number): void {
    eventTimestamp = timeStamp;
}

export function createMailListLoadDatapoint(
    actionSource: ActionSource,
    tableView: TableView
): void {
    // End the previous MLL datapoint if it did not complete before a new ML load.
    endMailListLoadDatapoint(
        'None' /*componentRendered*/,
        tableView.id,
        true /* shouldInvalidate */
    );

    const options = {
        timeout: 90 * 1000,
        eventTimestamp,
    };

    const mailboxInfo = getMailboxInfo(tableView);
    const mllDp = new PerformanceDatapoint('MailListLoad', mailboxInfo, options);
    mllDp.addCustomData({ act: actionSource });
    setMailListLoadDatapoint(mllDp);
}
